import type { Dict } from "../types";

export const dataTable: Dict = {
  en: {
    "DataTable.columns": "Columns",
    "DataTable.columnsHint": "Check to show, drag to reorder.",
    "DataTable.alwaysShown": "always shown",
    "DataTable.moveUp": "Move {column} up",
    "DataTable.moveDown": "Move {column} down",
    "DataTable.dragHandle": "Drag {column}",
    "DataTable.reset": "Reset",
    "DataTable.done": "Done",
    "DataTable.saved": "Saved",
    "DataTable.undo": "Undo",
    "DataTable.undone": "Change undone",
    "DataTable.editCell": "Edit {field}",
  },
  fr: {
    "DataTable.columns": "Colonnes",
    "DataTable.columnsHint": "Cochez pour afficher, glissez pour réordonner.",
    "DataTable.alwaysShown": "toujours affichée",
    "DataTable.moveUp": "Monter {column}",
    "DataTable.moveDown": "Descendre {column}",
    "DataTable.dragHandle": "Glisser {column}",
    "DataTable.reset": "Réinitialiser",
    "DataTable.done": "Terminé",
    "DataTable.saved": "Enregistré",
    "DataTable.undo": "Annuler",
    "DataTable.undone": "Modification annulée",
    "DataTable.editCell": "Modifier {field}",
  },
};
